// extracted by mini-css-extract-plugin
export default {"time":"timer_time__K5tCh"};